import { Reveal, SectionHeader } from "./Reveal";
import { SERVICES } from "../data/content";

export const Services = () => (
  <section id="services" data-testid="services-section" className="border-t border-white/10 bg-ink-2 py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
        <SectionHeader eyebrow="What We Build" title="From One Room to a Complete Transformation" />
        <Reveal delay={0.15}>
          <p className="max-w-sm text-sm leading-relaxed text-gray-400 lg:text-right">
            From renovation to brand-new construction — every project is managed with the same
            attention to craftsmanship and the finished result.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-px border border-white/10 bg-white/10 md:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((service, i) => (
          <Reveal key={service.title} delay={0.08 * i} className={i === 0 ? "md:col-span-2 lg:col-span-1 lg:row-span-2" : ""}>
            <article
              data-testid={`service-card-${i}`}
              className="group relative flex h-full flex-col bg-ink-2 transition-colors duration-500 hover:bg-ink-3"
            >
              <div className={`relative overflow-hidden ${i === 0 ? "aspect-[4/3] lg:aspect-auto lg:flex-1" : "aspect-[4/3]"}`}>
                <img
                  src={service.image}
                  alt={service.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-2 via-transparent to-transparent" aria-hidden="true" />
              </div>
              <div className="relative p-8">
                <span className="font-accent text-[10px] font-semibold uppercase tracking-[0.3em] text-gold/80" aria-hidden="true">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="mt-3 font-serif text-2xl font-medium leading-snug text-white md:text-3xl">
                  {service.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-gray-400">{service.description}</p>
                <span
                  className="mt-6 block h-px w-10 bg-gold/50 transition-all duration-500 group-hover:w-full group-hover:bg-gold"
                  aria-hidden="true"
                />
              </div>
            </article>
          </Reveal>
        ))}

        <Reveal delay={0.4}>
          <a
            href="#contact"
            data-testid="services-cta-card"
            className="group flex h-full min-h-[220px] flex-col justify-between bg-gold p-8 transition-colors duration-500 hover:bg-gold-hover focus:outline-none focus:ring-2 focus:ring-gold"
          >
            <p className="font-serif text-2xl font-medium leading-snug text-black md:text-3xl">
              Have something else in mind?
            </p>
            <span className="mt-8 inline-flex items-center gap-3 font-accent text-xs font-semibold uppercase tracking-[0.25em] text-black">
              Tell Us About It
              <span className="transition-transform duration-300 group-hover:translate-x-1.5" aria-hidden="true">→</span>
            </span>
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
